import classNames from 'classnames'

import { useScreen } from '../../../hooks'
import { Skeleton } from '../../Skeleton'
import { TablePaginationNavigation } from '../TablePaginationNavigation'
import { TablePaginationPageInput } from '../TablePaginationPageInput'
import { TablePaginationPages } from '../TablePaginationPages'

import { getIsTablePaginationResponsive } from './TablePagination.utils'

import * as styles from './TablePagination.module.css'

function TablePagination({
  className = styles.TablePagination,
  containerRef,
  disabled,
  isSkeleton,
  navigationProps,
  pagesProps,
  responsive,
  value,
  onChange,
}) {
  const { width: screenWidth } = useScreen({ containerRef })

  const isMobileScreenSize = getIsTablePaginationResponsive({
    responsive,
    screenWidth,
  })

  return isSkeleton ? (
    <div className={classNames(className, styles.skeletonContainer)}>
      <Skeleton className={styles.skeletonSquare} />
      <Skeleton className={styles.skeletonBar} />
      <Skeleton className={styles.skeletonSquare} />
    </div>
  ) : value.pageCount ? (
    <div
      className={classNames(className, {
        [styles.onePage]: value.pageCount === 1,
      })}
    >
      {value.pageCount > 1 ? (
        <>
          <TablePaginationPageInput
            disabled={disabled}
            value={value}
            onSubmit={onChange}
          />
          <TablePaginationNavigation
            {...navigationProps}
            disabled={disabled}
            isMobileScreenSize={isMobileScreenSize}
            value={value}
            onChange={onChange}
          >
            <TablePaginationPages
              {...pagesProps}
              disabled={disabled}
              isMobileScreenSize={isMobileScreenSize}
              value={value}
              onChange={onChange}
            />
          </TablePaginationNavigation>
        </>
      ) : (
        <TablePaginationPages
          disabled={disabled}
          value={value}
          onChange={onChange}
        />
      )}
    </div>
  ) : null
}

export default TablePagination
